import type { FacilityPayload } from '@Application/Facilities/Facilities/Actions/facilitiesFetched';

export type FacilityCreatedPayload = FacilityPayload;

export type FacilityCreatedAction = {
	type: 'FACILITY_CREATED';
	payload: FacilityCreatedPayload;
	organizationId: number;
};

export default (payload: FacilityCreatedPayload, organizationId: number): FacilityCreatedAction => ({
	type: 'FACILITY_CREATED',
	payload,
	organizationId,
});
